import createReactComponent from '../createReactComponent';
export default createReactComponent('plus-circle', 'PlusCircle', [["path",{"d":"M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0m-5.5 0H12m0 0H8.5m3.5 0V8.5m0 3.5v3.5","key":"svg-0"}]]);